import { getErrorMessage } from '@onefootprint/fetch-hosted';
import { useEffect, useState } from 'react';
import { getCameraPermissionState } from '@/idv2/utils/get-device';
import { Logger } from '@/idv2/utils/logger';
import useSubmitDocType from '../../../hooks/use-submit-doc-type';
import { isMobileKind } from '../../../utils/capture';
import { useSelfieMachine } from '../../context/selfie-context';
import InitView from './init-view';
const Init = () => {
  const [state, dispatch] = useSelfieMachine();
  const {
    authToken,
    device,
    requirement
  } = state.context;
  const submitDocTypeMutation = useSubmitDocType();
  const {
    isError
  } = submitDocTypeMutation;
  const [numRetries, setNumRetries] = useState(0);
  const retryLimitExceeded = numRetries >= 3;
  useEffect(() => {
    submitDocTypeMutation.mutate({
      body: {
        documentType: 'selfie',
        requestId: requirement.documentRequestId,
        deviceType: isMobileKind(device.type) ? 'mobile' : 'desktop'
      },
      headers: {
        'X-Fp-Authorization': authToken
      }
    }, {
      onSuccess: async data => {
        const cameraPermissionState = await getCameraPermissionState();
        dispatch({
          type: 'contextInitialized',
          payload: {
            id: data.id,
            cameraPermissionState
          }
        });
      },
      onError: err => {
        Logger.error(`Failed to create selfie document. Error: ${getErrorMessage(err)}`, {
          location: 'selfie-init'
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numRetries]);
  return <InitView isError={isError} retryLimitExceeded={retryLimitExceeded} onRetry={() => setNumRetries(prev => prev + 1)} />;
};
export default Init;